"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var idlUtils = require("../generated/utils");

var NodeList = require("../generated/NodeList");

var HTMLCollection = require("../generated/HTMLCollection");

var _require = require("../helpers/selectors"),
    addNwsapi = _require.addNwsapi;

var _require2 = require("../helpers/internal-constants"),
    domSymbolTree = _require2.domSymbolTree;

var NODE_TYPE = require("../node-type");

var _require3 = require("../../utils"),
    memoizeQuery = _require3.memoizeQuery;

var _require4 = require("../node"),
    convertNodesIntoNode = _require4.convertNodesIntoNode;

var ParentNodeImpl = /*#__PURE__*/function () {
  function ParentNodeImpl() {
    _classCallCheck(this, ParentNodeImpl);
  }

  _createClass(ParentNodeImpl, [{
    key: "append",
    value: function append() {
      for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
        nodes[_key] = arguments[_key];
      }

      this.appendChild(convertNodesIntoNode(this._ownerDocument, nodes));
    }
  }, {
    key: "prepend",
    value: function prepend() {
      for (var _len2 = arguments.length, nodes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nodes[_key2] = arguments[_key2];
      }

      this.insertBefore(convertNodesIntoNode(this._ownerDocument, nodes), this.firstChild);
    }
  }, {
    key: "children",
    get: function get() {
      var _this = this;

      if (!this._childrenList) {
        this._childrenList = HTMLCollection.createImpl([], {
          element: this,
          query: function query() {
            return domSymbolTree.childrenToArray(_this, {
              filter: function filter(node) {
                return node.nodeType === NODE_TYPE.ELEMENT_NODE;
              }
            });
          }
        });
      } else {
        this._childrenList._update();
      }

      return this._childrenList;
    }
  }, {
    key: "firstElementChild",
    get: function get() {
      var _iterator = _createForOfIteratorHelper(domSymbolTree.childrenIterator(this)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;

          if (child.nodeType === NODE_TYPE.ELEMENT_NODE) {
            return child;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
  }, {
    key: "lastElementChild",
    get: function get() {
      var _iterator2 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(this, {
        reverse: true
      })),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;

          if (child.nodeType === NODE_TYPE.ELEMENT_NODE) {
            return child;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null;
    }
  }, {
    key: "childElementCount",
    get: function get() {
      return this.children.length;
    }
  }]);

  return ParentNodeImpl;
}();

ParentNodeImpl.prototype.querySelector = memoizeQuery(function (selectors) {
  if (shouldAlwaysSelectNothing(this)) {
    return null;
  }

  var matcher = addNwsapi(this);
  return idlUtils.implForWrapper(matcher.first(selectors, idlUtils.wrapperForImpl(this)));
}); // WARNING: this returns a NodeList containing IDL wrappers instead of impls

ParentNodeImpl.prototype.querySelectorAll = memoizeQuery(function (selectors) {
  if (shouldAlwaysSelectNothing(this)) {
    return NodeList.create([], {
      nodes: []
    });
  }

  var matcher = addNwsapi(this);
  var list = matcher.select(selectors, idlUtils.wrapperForImpl(this));
  return NodeList.create([], {
    nodes: list.map(function (n) {
      return idlUtils.tryImplForWrapper(n);
    })
  });
});

function shouldAlwaysSelectNothing(elImpl) {
  // The latter clause is true during initialization.
  return !domSymbolTree.hasChildren(elImpl) || elImpl === elImpl._ownerDocument && !elImpl.documentElement;
}

module.exports = {
  implementation: ParentNodeImpl
};